import React from 'react';
import cls from './StatusDot.module.scss';

interface Props {
  active: boolean;
  size?: number;
  className?: string;
}

export const StatusDot: React.FC<Props> = ({ active, size = 8, className }) => {
  return (
    <span
      className={[cls.dot, active ? cls.active : cls.inactive, className].filter(Boolean).join(' ')}
      style={{ width: size, height: size }}
      aria-label={active ? 'active' : 'inactive'}
    />
  );
};
